import React, { useEffect, useState } from "react";
import { Sidebar } from "./Sidebar";
import { Header } from "./Header";
import { AppUseNotification } from "app/pages/component/AppUseNotification";
import { useDispatch } from "react-redux";
import { AppDispatch } from "sr/redux/store";
import { fetchAppSettings } from "sr/redux/reducers/appSettings";
export const MainWrapper = ({ children }) => {
  const dispatch = useDispatch<AppDispatch>();
  const [isOpen, setIsOpen] = useState(true);
  const HandleOpen = () => {
    setIsOpen(!isOpen);
  };
  useEffect(() => {
    dispatch(fetchAppSettings());
    // (async () => {
    // const res = await fetchAppSettings();
    // })();
    return () => {};
  }, []);
  return (
    <>
      <AppUseNotification></AppUseNotification>

      <Sidebar isOpen={isOpen} HandleOpen={HandleOpen} />
      <Header isOpen={isOpen} />
      <main
        className={`${isOpen ? "pl-52" : "pl-20"} duration-300 bg-white px-5`}
      >
        {children}
      </main>
    </>
  );
};
